<template>
    <div v-if="valid" class="col-lg-12 d-flex flex-column justify-content-between align-items-center company__image">
        <img :src="header" @error="valid = false"/>
        <div>
        </div>
        <div class="banner__bottom">
        </div>
    </div>
    <div v-else class="col-lg-12 d-flex flex-column justify-content-between align-items-center company__image">
        <img :src="headerDefault"/>
        <div>
        </div>
        <div class="banner__bottom">
        </div>
    </div>

</template>

<script>
export default {
    props: ['header','headerDefault'],
    data() {
        return {
            valid: true,
        }
    }
}
</script>
